import type { RigViewModel } from "./types";

export interface SignalNodeLabel {
  eyebrow: string;
  line1: string;
  line2: string;
}

export function signalNodeLabel(vm: RigViewModel): SignalNodeLabel {
  const company = vm.orgs.find((organization) => organization.role === "signal")?.name ?? "Signal";
  return {
    eyebrow: `SIGNAL · ${vm.brief.category}`,
    line1: company,
    line2: vm.brief.dealSize ?? "",
  };
}

export function composeSignalNodeLabel(label: SignalNodeLabel): string {
  return label.line2 ? `${label.line1} — ${label.line2}` : label.line1;
}
